var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 78,
    viewBox: "0 0 70 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 27.9066L60.1977 30.3279L57.0845 48.4322L39.6721 59.5014L33.9039 77.4933L20.4133 68.1536L30.5615 56.5049L0.579519 25.5975L0 0L44.398 28.7107L56.0467 17.6415L70 27.9066Z",
    fill: "#1563A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.916 15.9839L43.4767 24.4475L51.4326 16.8329L52.0077 2.65054L40.0175 5.18873L30.916 15.9839Z",
    fill: "#1A2753"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleLogo);
export default __webpack_public_path__ + "static/media/single-logo.2fcb5a7a3dc1620fe2df3f18f7354aa8.svg";
export { ForwardRef as ReactComponent };